import ReactGA from "react-ga";
import eventsJson from "./events.json";

ReactGA.initialize("UA-82267497-3");
type func = (fleetName: string) => void;
interface Events {
  lead: {
    navbarCta: func;
    navbarLogo: func;
  };
  mapInteraction: {
    trafficOff: func;
    trafficOn: func;
  };
  sharing: {
    copiedToClipboard: func;
    sidebarCta: func;
    whatsappShare: func;
  };
  rating: {
    submitted: (thumbsUp: boolean) => void;
  };
}
let events: Events;
// @ts-ignore
events = {};
// @ts-ignore
Object.keys(eventsJson.eventsByCategory).forEach(category => {
  // @ts-ignore
  events[category] = {};
  // @ts-ignore
  Object.keys(eventsJson.eventsByCategory[category]).forEach(event => {
    const sendEvent = function(fleetName: string) {
      ReactGA.ga(
        "send",
        "event",
        // @ts-ignore
        Object.assign(eventsJson.eventsByCategory[category][event], {
          eventLabel: fleetName,
          // @ts-ignore
          eventCategory: eventsJson.categories[category]
        })
      );
    };
    // @ts-ignore
    events[category][event] = sendEvent;
  });
});
// @ts-nocheck

export default events;
